<template>
  <svg :width="width" :height="height">
    <g v-if="data" :transform="graphTransform">
      <orthogonal-axes
         ref="axes"
         :width="graphWidth"
         :height="graphHeight"
         :x="x"
         :y="y"
         :xTitle="xTitle"
         :yTitle="yTitle"
         :xFormatter="xFormatter"
         :yFormatter="yFormatter" >
      </orthogonal-axes>
      <path
         fill="none"
         stroke="steelblue"
         stroke-linejoin="round"
         stroke-linecap="round"
         stroke-width="1.5"
         :d="path" >
      </path>
    </g>
  </svg>
</template>

<style scoped>
</style>

<script>
import * as d3 from 'd3'
import Graph from './Graph.vue'
import margin from '../mixins/margin.js'
import OrthogonalAxes from './OrthogonalAxes.vue'

export default {
  extends: Graph,
  mixins: [
    margin
  ],
  components: {
    OrthogonalAxes: OrthogonalAxes
  },
  props: {
    xKey: {
      type: String,
      default: 'x'
    },
    yKey: {
      type: String,
      default: 'y'
    },
    curve: {
      default: () => {
        return d3.curveMonotoneX
      }
    },
    scaleX: {
      default: () => {
        return d3.scalePoint
      }
    },
    scaleY: {
      default: () => {
        return d3.scaleLinear
      }
    }
  },
  data () {
    return {
      mouseX: null,
      showTooltip: false,
      tooltipInitialized: false
    }
  },
  mounted () {
    this.initializeTooltip()
  },
  computed: {
    x () {
      return this
        .scaleX()
        .rangeRound([0, this.graphWidth])
        .domain(this.data.map(d => d[this.xKey]))
    },
    y () {
      return this
        .scaleY()
        .rangeRound([this.graphHeight, 0])
        .domain(d3.extent(this.data, d => d[this.yKey]))
    },
    line () {
      return d3.line().curve(this.curve).x(d => this.x(d[this.xKey])).y(d => this.y(d[this.yKey]))
    },
    path () {
      return this.line(this.data)
    },
    tooltipPath () {
      if (this.mouseX === null) {
        return null
      }
      return 'M' + this.x(this.mouseX) + ',' + this.graphHeight + ' ' + this.x(this.mouseX) + ',0'
    },
    tooltipTransform () {
      return y => 'translate(' + this.x(this.mouseX) + ',' + this.y(this.tooltipValue(y)) + ')'
    },
    tooltipValue () {
      return y => {
        const d = this.data.find(d => d[this.xKey] === this.mouseX)
        return d ? d[y] : 0
      }
    }
  },
  methods: {
    tooltipTextPosition (i) {
      const a = i * Math.PI / 2
      const x = Math.sin(a)
      return {
        x: x * 10,
        y: Math.cos(a) * (15 * (i % 4 ? 1 : 2)),
        'text-anchor': ['end', 'middle', 'start'][Math.round(x) + 1]
      }
    },
    update () {
      this.$nextTick(() => {
        if (typeof this.$refs.axes !== 'undefined') {
          this.$refs.axes.draw()
        }
        if (!this.tooltipInitialized) {
          this.initializeTooltip()
        }
      })
    },
    initializeTooltip () {
      if (typeof this.$refs.mousearea !== 'undefined') {
        const vm = this
        d3.select(this.$refs.mousearea).on('mousemove', function () {
          vm.mouseX = vm.x.domain()[Math.round(d3.mouse(this)[0] / vm.x.step())]
        })
        this.tooltipInitialized = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/Line.vue